import { application } from "./application";

import { AccordionController } from "./accordion_controller";
application.register("accordion", AccordionController);

import ShowIfController from "./show_if_controller";
application.register("show-if", ShowIfController);

import AdmissionPrintController from "./admission_print_controller";
application.register("admission-print", AdmissionPrintController);

import AdmissionNavController from "./admission_nav_controller";
application.register("admission-nav", AdmissionNavController);

import AgreementController from "./agreement_controller";
application.register("agreement", AgreementController);

import ApplicationLimitController from "./promoters/events/application_limit_controller";
application.register("promoters--events--application-limit", ApplicationLimitController);

import BankController from "./bank_controller";
application.register("bank", BankController);

import BannerController from "./banner_controller";
application.register("banner", BannerController);

import { CheckAllController } from "./check_all_controller";
application.register("check-all", CheckAllController);

import { CheckSubmitController } from "./check_submit_controller";
application.register("check-submit", CheckSubmitController);

import CancelReservesController from "./promoters/events/cancel_reserves_controller";
application.register("promoters--events--cancel-reserves", CancelReservesController);

import RegistrablesController from "./promoters/events/registrables_controller";
application.register("promoters--events--registrables", RegistrablesController);

import { ChartController } from "./chart_controller";
application.register("chart", ChartController);

import { CheckBoxController } from "./check_box_controller";
application.register("check_box", CheckBoxController);

import { ClickableAreaController } from "./clickable_area_controller";
application.register("clickable-area", ClickableAreaController);

import { ConfirmController } from "./confirm_controller.js";
application.register("confirm", ConfirmController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ConfirmationsController from "./confirmations_controller";
application.register("confirmations", ConfirmationsController);

import DateFilterController from "./promoters/payment_statements/date_filter_controller";
application.register("promoters--payment-statements--date-filter", DateFilterController);

import { DatepickerController } from "./datepicker_controller";
application.register("datepicker", DatepickerController);

import EventPageController from "./event_page_controller";
application.register("event-page", EventPageController);

import { EventIdsController } from "./event_ids_controller";
application.register("event-ids", EventIdsController);

import { EventOnlineController, EventPeriodController } from "./event_period_controller";
application.register("event-online", EventOnlineController);
application.register("event-period", EventPeriodController);

import { DrawerButtonController } from "./drawer_controller";
application.register("drawer-button", DrawerButtonController);

import DownloadOnceController from "./download_once_controller";
application.register("download-once", DownloadOnceController);

import DrawerController from "./drawer_controller";
application.register("drawer", DrawerController);

import { EditableController } from "./editable_controller.js";
application.register("editable", EditableController);

import EventsRefundRequestsController from "./promoters/events/refund_requests_controller";
application.register("promoters--events--refund-requests", EventsRefundRequestsController);

import EnteredSwitchController from "./entered_switch_controller";
application.register("entered", EnteredSwitchController);

import FileController from "./file_controller";
application.register("file", FileController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import { FieldArrayController } from "./field_array_controller";
application.register("field-array", FieldArrayController);

import { FormConfirmationController } from "./form_confirmation_controller.js";
application.register("form-confirmation", FormConfirmationController);

import FlashToastController from "./flash_toast_controller";
application.register("flash-toast", FlashToastController);

import FlatpickrController from "./flatpickr_controller";
application.register("flatpickr", FlatpickrController);

import GlobalNavController from "./global_nav_controller";
application.register("global-nav", GlobalNavController);

import { HalfModalPopoverController, HalfModalPopoverManagerController } from "./half_modal_popover_controller";
application.register("half-modal-popover", HalfModalPopoverController);
application.register("half-modal-popover-manager", HalfModalPopoverManagerController);

import ImageUploadController from "./image_upload_controller";
application.register("image-upload", ImageUploadController);

import { LargeCategorySelectController } from "./large_category_select_controller.js";
application.register("large-category-select", LargeCategorySelectController);

import LotteryDetailsController from "./promoters/events/lotteries/lottery_details_controller.js";
application.register("promoters--events--lotteries--lottery-details", LotteryDetailsController);

import { MapController } from "./map_controller";
application.register("map", MapController);

import { ModalController, ModalButtonController } from "./modal_controller";
application.register("modal", ModalController);
application.register("modal-button", ModalButtonController);

import { MultipleUploadController } from "./multiple_upload_controller.js";
application.register("multiple-upload", MultipleUploadController);
import MailsController from "./promoters/events/mails_controller";

application.register("promoters--events--mails", MailsController);

import PasswordController from "./password_controller";
application.register("password", PasswordController);

import PaymentMethodController from "./payment_method_controller";
application.register("payment-method", PaymentMethodController);

import PromotersEventGroupsLinksController from "./promoters/event_groups/links_controller";
application.register("promoters--event-groups--links", PromotersEventGroupsLinksController);

import PromotersEventGroupsPublishController from "./promoters/event_groups/publish_controller";
application.register("promoters--event-groups--publish", PromotersEventGroupsPublishController);

import PromotersEventGroupsController from "./promoters/event_groups_controller";
application.register("promoters--event-groups", PromotersEventGroupsController);

import TicketTransferController from "./promoters/events/ticket_transfer_controller"; // TicketTransferControllerをインポート
application.register("promoters--events--ticket-transfer", TicketTransferController);

import TitleController from "./title_controller";
application.register("title", TitleController);

import PromoterEventsController from "./promoters/seller_infos/promoter_events_controller";
application.register("promoters--seller-infos--promoter-events", PromoterEventsController);

import PromoterStaffSettingsController from "./promoters/promoter_staff_settings_controller";
application.register("promoters--promoter-staff-settings", PromoterStaffSettingsController);

import PerformerController from "./promoters/performer_controller.js";
application.register("promoters--performer", PerformerController);

import PromotersController from "./promoters_controller";
application.register("promoters", PromotersController);

import QrcodeController from "./qrcode_controller";
application.register("qrcode", QrcodeController);

import { QuestionnaireController } from "./questionnaire_controller";
application.register("questionnaire", QuestionnaireController);

import { QuestionController } from "./question_controller";
application.register("question", QuestionController);

import RadioController from "./radio_controller";
application.register("radio", RadioController);

import { RadioToggleController } from "./radio_toggle_controller";
application.register("radio-toggle", RadioToggleController);

import RefundRequestsController from "./promoters/refund_requests_controller";
application.register("promoters--refund-requests", RefundRequestsController);

import RangeFlatpickrController from "./range_flatpickr_controller";
application.register("range-flatpickr", RangeFlatpickrController);

import ReceptionsController from "./promoters/events/performances/receptions_controller";
application.register("promoters--events--performances--receptions", ReceptionsController);

import { ReceptionTicketsController, AddTicketsController } from "./reception_tickets_controller";
application.register("reception-tickets", ReceptionTicketsController);
application.register("add-tickets", AddTicketsController);

import ScrollController from "./scroll_controller";
application.register("scroll", ScrollController);

import SmoothScrollController from "./smooth_scroll_controller";
application.register("smooth-scroll", SmoothScrollController);

import SelectModalController from "./select_modal_controller";
application.register("select-modal", SelectModalController);

import { SelectedItemController } from "./selected_item_controller";
application.register("selected-item", SelectedItemController);

import SellerInfosController from "./promoters/seller_infos_controller";
application.register("promoters--seller-infos", SellerInfosController);

import SortController from "./sort_controller";
application.register("sort", SortController);

import SubmitGroupController from "./submit_group_controller";
application.register("submit-group", SubmitGroupController);

import SortHalfModalController from "./sort_half_modal_controller";
application.register("sort-half-modal", SortHalfModalController);

import { StickyController } from "./sticky_controller.js";
application.register("sticky", StickyController);

import { SummernoteController } from "./summernote_controller.js";
application.register("summernote", SummernoteController);

import TabController from "./tab_controller";
application.register("tab", TabController);

import { TicketDrawerController, TicketDrawerButtonController } from "./ticket_drawer_controller";
application.register("ticket-drawer", TicketDrawerController);
application.register("ticket-drawer-button", TicketDrawerButtonController);

import { TextMoreController } from "./text_more_controller.js";
application.register("text-more", TextMoreController);

import TipsController from "./tips_controller";
application.register("tips", TipsController);

import { ToastController } from "./toast_controller";
application.register("toast", ToastController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import { DailySalesController } from "./promoters/events/daily_sales_controller";
application.register("daily-sales", DailySalesController);

import EventHubController from "./promoters/event_hub_controller.js";
application.register("promoters--event-hub", EventHubController);

import EventVisibilitySettingsController from "./promoters/events/visibility_settings_controller.js";
application.register("promoters--events--visibility-settings", EventVisibilitySettingsController);

import { UploadButtonController } from "./upload_button_controller";
application.register("upload-button", UploadButtonController);

import PasswordReauthController from "./password_reauth_controller";
application.register("password-reauth", PasswordReauthController);

import ReceptionController from "./promoters/events/performances/receptions_controller";
application.register("promoters--events--performances--receptions", ReceptionController);
import MasterTicketsController from "./promoters/events/performances/master_tickets_controller.js";
application.register("promoters--events--performances--master-tickets", MasterTicketsController);

import PromotersEventsController from "./promoters/events_controller";
application.register("promoters--events", PromotersEventsController);

import ToggleFormController from "./toggle_form_controller";
application.register("toggle-form", ToggleFormController);

import {
  MasterTicketFormController,
  StockQuantityFormController,
} from "./promoters/events/performances/master_ticket_form_controller";
application.register("master-ticket-form", MasterTicketFormController);
application.register("stock-quantity-form", StockQuantityFormController);

import { PreviewFormController, TicketController } from "./promoters/events/performances/ticket_preview_controller";
application.register("preview-form", PreviewFormController);
application.register("ticket", TicketController);

import RedirectOpenTabController from "./redirect_open_tab_controller";
application.register("redirect-open-tab", RedirectOpenTabController);

import EventHeaderController from "./event_header_controller";
application.register("event-header", EventHeaderController);

// GTMタグ
import GtmPublicController from "./gtm_public_controller.js";
application.register("gtm-public", GtmPublicController);

import GtmSpaPageiewController from "./gtm_spa_pageview_controller.js";
application.register("gtm-spa-pageview", GtmSpaPageiewController);

import GtmPromoterSignUpController from "./gtm_promoter_sign_up_controller.js";
application.register("gtm-promoter-sign-up", GtmPromoterSignUpController);

import GtmPromoterCreateEventCompleteController from "./gtm_promoter_create_event_complete_controller.js";
application.register("gtm-promoter-create-event-complete", GtmPromoterCreateEventCompleteController);

import GtmTrEventClickController from "./gtm_tr_event_click_controller.js";
application.register("gtm-tr-event-click", GtmTrEventClickController);

import SeatController from "./seat_controller.js";
application.register("seat", SeatController);

import {
  CustomCommissionsController,
  CommissionPreviewController,
  CommissionPreviewFormController,
} from "./promoters/events/custom_commissions_controller";
application.register("promoters--events--custom-commissions", CustomCommissionsController);
application.register("commission-preview-form", CommissionPreviewFormController);
application.register("commission-preview", CommissionPreviewController);

import CommissionMethodController from "./commission_method_controller";
application.register("commission-method", CommissionMethodController);
import CommissionPayerController from "./commission_payer_controller";
application.register("commission-payer", CommissionPayerController);

import { FieldSortController } from "./field_sort_controller";
application.register("field-sort", FieldSortController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);
